import { render, staticRenderFns } from "./BigOccupationArea.vue?vue&type=template&id=ebc13522"
import script from "./BigOccupationArea.vue?vue&type=script&lang=js"
export * from "./BigOccupationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports